<template>
    <ReaderModal
        :fixed-height="false"
        :aria-label="localizations[lang].lists || 'Lists'"
        @close-modal="toggleShowAddToLists"
    >
        <template #header>
            <h2 class="mb-0 pl-4">{{ localizations[lang].lists }}</h2>
        </template>
        <LoadingSpinner
            class="Spinner absolute bottom-0 flex h-auto scale-50 p-4"
            :not-centered="true"
            data-cy="iframeIsLoading"
        />
        <Container>
            <Row class="h-auto w-full">
                <LayoutCol>
                    <div
                        id="iframe-container"
                        class="relative min-h-20 w-full overflow-hidden transition-all duration-150 ease-in-out"
                    >
                        <!-- The design of this components should be improve on farfalla-->
                        <iframe
                            ref="iframe"
                            :src="iframeUrl"
                            :title="localizations[lang].lists || 'Lists'"
                            class="transition-height absolute left-0 top-0 h-full w-full overflow-hidden border-none px-3"
                            sandbox="allow-same-origin allow-scripts"
                        >
                        </iframe>
                    </div>
                </LayoutCol>
            </Row>
        </Container>
    </ReaderModal>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import ReaderModal from '../ReaderModal/ReaderModal.vue';
import LoadingSpinner from '../Utilities/LoadingSpinner.vue';
import PostMessageHandler from '../../../src/js/PostMessageHandler';

export default {
    components: {
        ReaderModal,
        LoadingSpinner,
    },
    data() {
        return {
            iframe: null,
        };
    },
    computed: {
        ...mapState(['issue', 'addToLists', 'localizations', 'lang', 'ui', 'embeddedInMobileApp', 'parentUrl']),
        iframeUrl() {
            const url = new URL(this.addToLists.iframeUrl);
            url.searchParams.set('color_scheme', this.ui.themeSelected);
            return url.toString();
        },
    },
    async mounted() {
        this.iframe = document.querySelector('#iframe-container');
        window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        ...mapMutations(['toggleShowAddToLists', 'openToast']),
        handleMessage(message) {
            /*
             * Disables message listening in certain mobile embed scenarios.
             * On mobile devices, some message handling might not be required for proper functionality.
             * For instance, in embedded views within mobile apps, omitting message checking for correct height application.
             */

            if (
                !this.embeddedInMobileApp &&
                !PostMessageHandler.validatePostMessage(message, ['height', 'notify'], this.parentUrl)
            )
                return;

            if (message.data.name === 'height' && message.data.payload && this.iframe) {
                this.iframe.style.height = `${message.data.payload.height}px`;
            }
            if (message.data.name === 'notify' && message.data.payload) {
                this.openToast({ text: message.data.payload.message });
            }
        },
    },
};
</script>

<style lang="css" scoped>
.Spinner {
    z-index: 1;
}

.Spinner + div {
    z-index: 2;
}
</style>
